import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ChatInput from "./ChatInput";
import Logout from "./Logout";
import axios from "axios";
import {
  deleteFriendRoute,
  getAllMessagesRoute,
  sendMessageRoute,
} from "../utils/APIRoutes";
import { BsTrash } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import { v4 as uuidv4 } from "uuid";

const ChatContainer = ({
  currentChat,
  setCurrentChat,
  currentUser,
  socket,
  setCloseSideBar,
  getFriends,
}) => {
  const [messages, setMessages] = useState([]);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [toggleDelete, setToggleDelete] = useState(false);

  const scrollRef = useRef(null);

  const getMessages = async () => {
    const response = await axios.post(getAllMessagesRoute, {
      from: currentUser.user_id,
      to: currentChat.user_id,
    });
    setMessages(response.data);
  };

  const deleteChat = async () => {
    const deletedChat = await axios.delete(
      `${deleteFriendRoute}/${currentUser.user_id}/${currentChat.user_id}`
    );
    getFriends();
    setToggleDelete(false);
    setCurrentChat(undefined);
    setCloseSideBar(true);
  };

  useEffect(() => {
    if (currentChat) {
      getMessages();
    }
  }, [currentChat]);
  const handleSendMsg = async (msg) => {
    await axios.post(sendMessageRoute, {
      from: currentUser.user_id,
      to: currentChat.user_id,
      message: msg,
    });

    socket.current.emit("send-msg", {
      to: currentChat.user_id,
      from: currentUser.user_id,
      message: msg,
    });

    const msgs = [...messages];
    msgs.push({ fromSelf: true, message: msg });
    setMessages(msgs);
  };

  useEffect(() => {
    if (socket.current) {
      socket.current.on("msg-recieve", (msg) => {
        setArrivalMessage({ fromSelf: false, message: msg });
      });
    }
  }, [socket]);

  useEffect(() => {
    arrivalMessage && setMessages((prev) => [...prev, arrivalMessage]);
  }, [arrivalMessage]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <>
      {currentChat && (
        <Container>
          <div className="chat-header">
            <div className="user-details">
              <div className="avatar">
                <img
                  src={`data:image/svg+xml;base64,${currentChat.avatarimage}`}
                  alt="avatar"
                />
              </div>
              <div className="username">
                <h3>{currentChat.username}</h3>
              </div>
            </div>
            <div className="delete" onClick={() => setToggleDelete(true)}>
              <BsTrash size="1.5rem" />
            </div>
            <div className={toggleDelete ? "modal-bg" : "hide-modal"}>
              <div className="modal">
                <div className="header-div">
                  <p>Are you sure?</p>
                  <AiOutlineClose
                    onClick={() => setToggleDelete(false)}
                    size="1.8rem"
                  />
                </div>
                <hr />
                <div className="body-div">
                  <p>
                    This will delete all your messages you have with{" "}
                    {currentChat.username}.
                  </p>
                </div>
                <div className="footer-div">
                  <button onClick={deleteChat}>Delete Anyway</button>
                </div>
              </div>
            </div>
          </div>
          <div className="chat-messages">
            {messages.length === 0
              ? null
              : messages.map((message) => {
                  return (
                    <div ref={scrollRef} key={uuidv4()}>
                      <div
                        className={`message ${
                          message.fromSelf ? "sended" : "recieved"
                        }`}
                      >
                        <div className="content">
                          <p>{message.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
          <ChatInput handleSendMsg={handleSendMsg} />
        </Container>
      )}
    </>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-rows: 10% 78% 12%;
  gap: 0.1rem;
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  transition: all 1s;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    grid-template-rows: 15% 70% 15%;
  }
  .chat-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    .user-details {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 1rem;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          color: white;
        }
      }
    }
    .delete {
      position: absolute;
      color: #c8c4c4;
      cursor: pointer;
      right: 1rem;
    }
  }
  .hide-modal {
    display: none;
  }

  .modal-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    min-width: 100%;
    min-height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    .modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 400px;
      min-width: 300px;
      height: 200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #c8c4c4;
      background-color: #1f1f1f;
      border-radius: 0.5rem;
      padding: 1rem;
      .header-div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 1.5rem;
        }
        svg {
          cursor: pointer;
        }
      }
      hr {
        margin-top: -1rem;
      }
      .body-div {
        p {
          margin: 0 auto;
          font-size: 1.2rem;

          text-align: center;
        }
      }
      .footer-div {
        display: flex;
        justify-content: flex-end;
        button {
          font-size: 1.1rem;
          background-color: #1f1f1f;
          color: #c8c4c4;
          border: 1px solid #c8c4c4;
          border-radius: 0.5rem;
          padding: 0.5rem 1rem;
          cursor: pointer;
          &:hover {
            background-color: #c8c4c4;
            color: #1f1f1f;
          }
        }
      }
    }
  }

  .chat-messages {
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 1.5px;
    }
    .message {
      display: flex;
      align-items: center;
      .content {
        max-width: 70%;
        overflow-wrap: break-word;
        padding: 1rem;
        font-size: 1.1rem;
        border-radius: 1rem;
        color: #fff;
      }
    }
    .sended {
      justify-content: flex-end;
      .content {
        background-color: #1982fc;
      }
    }
    .recieved {
      justify-content: flex-start;
      .content {
        background-color: #3a3a3a;
      }
    }
  }
`;

export default ChatContainer;
